import React, { useState, useEffect } from "react";
import { API_URL } from "../../../constants/api";
import { getSharepointUrl } from "./sharepoint_api";
import FileUpload from "./index";
import CloudDownload from "@material-ui/icons/CloudDownload";
import CloseIcon from "@material-ui/icons/Close";
import Schedule from "@material-ui/icons/Schedule";
import { getSpsAPiRequest, apiRequest } from "../../../utils/api_service";
import { getSPSTokenData, setSPSToken } from "../../../constants/constants";

function FileAttachments({
  requestCode,
  setUploadFilesList,
  disabled = false,
  uploadFiles = () => {},
  showUploadBtn = false,
  downloadPermission = true,
  isDownloadOnly = false,
  hasAttachment = undefined,
  reload
}) {
  const [spsAllData, setSpsAllData] = useState([]);
  const [localAttach, setLocalAttach] = useState([]);
  const [selectedRequestCode, setRequestCode] = useState(requestCode);

  useEffect(() => {
    setRequestCode(selectedRequestCode);
    getSpsData();
  }, [requestCode, reload]);

	/**
	 * get all share point data
	 * @returns 
	 */
	function getSpsData() {
		if(hasAttachment != undefined && hasAttachment == false ) {
			setSpsAllData([])
			return;
		}
		else
		{
		if (getSPSTokenData()) {
			if (!requestCode) return;
			// getSpsAPiRequest(getSharepointUrl("getInnerFolder", requestCode)).then(
			getSpsAPiRequest(getSharepointUrl("getSpsByFolder", requestCode)).then(
				spsDataRes => {
					const allData = spsDataRes.value || [];
					// const fData = allData.filter(x => x.name.search(requestCode) !== -1);
					const fData = allData;
					setSpsAllData(fData || []);
				}
			);
		} else {
			apiRequest({
				url: API_URL.getSPSToken,
				params: { isHideLoader: true }
			}).then(({ data }) => {
				if (data) {
					setSPSToken(data);
					getSpsData();
				}
			});
		}
	}
	}

	/** 
	 * set locally upload files
	*/
	function setLocalUploadFiles(list) {
		setLocalAttach(list);
		setUploadFilesList(list);
	}

	/**
	 * remove locally selected files
	 * @param {*} name 
	 */
	function removeLocalSelected(name) {
		const newAttach = localAttach.filter(x => x.fileData.name !== name);
		setLocalUploadFiles(newAttach);
	}

	/**
	 * download file from blob
	 * @param {*} url 
	 * @param {*} fileName 
	 * @returns 
	 */
	const getSpBlob = (url, fileName) => {
		return new Promise(function(resolve) {
			fetch(url)
				.then(response => response.blob())
				.then(function(blob) {
					const dataUrl = URL.createObjectURL(blob);
					const link = document.createElement("a");
					link.href = dataUrl;
					link.setAttribute("download", fileName);

          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);

          return resolve(dataUrl);
        })
        .catch(() => {
          return resolve("");
        });
    });
  };

	/**
	 * download file
	 * @param {*} url 
	 * @param {*} fileName 
	 */
	async function downloadFileSP(url = "", fileName = "") {
		await getSpBlob(url, fileName);
	}

  return (
    <>
      {isDownloadOnly == false && (
        <FileUpload
          selectedCategory={"otherDocs"}
          getSpsData={getSpsData}
          selectedPropertyKey={requestCode}
          spsAllData={spsAllData}
          disabled={disabled || !downloadPermission}
          setUploadFilesList={setLocalUploadFiles}
          uploadFiles={uploadFiles}
          showUploadBtn={showUploadBtn && localAttach.length}
        />
      )}
      <div className={isDownloadOnly && "row sharepoint-download-file"}>
        {localAttach.map(x => (
          <div className={"fileListName"}>
            <Schedule />
            {x.fileData.name}
            <CloseIcon
              className={"close"}
              onClick={() => removeLocalSelected(x.fileData.name)}
            />
          </div>
        ))}
        {spsAllData.map(
          x =>
            x.folder == null && (
              <div
                className={
                  isDownloadOnly
                    ? "fileListName uploaded file-upload-margin"
                    : "fileListName uploaded"
                }
              >
                <CloudDownload
                  onClick={() =>
                    downloadFileSP(x["@microsoft.graph.downloadUrl"], x["name"])}
                />
                {x.name}
              </div>
            )
        )}
      </div>
    </>
  );
}

export default FileAttachments;
